interface ErrorResponse {
    status: number
    text: () => Promise<string>
    json: () => Promise<any>
}

export const handleError = async (error: ErrorResponse): Promise<void> => {
    if (error.status >= 400 && error.status < 600) {
        const message = (await error.text()) || (await error.json())
        throw new Error(message || 'Error')
    }
}
